import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import EmptyCart from "./EmptyCart";
import CartItem from './CartItem';
import CartController from 'partialComponents/CartController';
import { Link } from 'react-router-dom';
import { Trans, withTranslated } from 'components';

const propTypes = {
  cart: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

class Cart extends React.Component {
  render() {
    const { cart, t } = this.props;
    const empty = cart.ids.length === 0;
    if (empty) {
      return <EmptyCart />;
    }

    return (
      <div className="nav-toppanel--user-card-dropdown dropdown-open">
        <div className="nt--user-card-products-list">
          <CartController>
            {({ increment, decrement, change, remove }) => cart.ids.map(id => (
              <CartItem
                key={id}
                item={cart.elements[id]}
                increment={increment}
                decrement={decrement}
                change={change}
                remove={remove}
              />
            ))}
          </CartController>
        </div>
        <div className="nt--user-card-summary-wrapper">
          <div className="nt--user-card-summary-wrapper-inner">
            <div className="nt--user-card-summary-quantity">
              <h5>{t('Łączna liczba')}:</h5>
              <div>
                <strong>{cart.ids.length} <Trans>prod.</Trans></strong>
                <span>({cart.quantity} <Trans>szt.</Trans>)</span>
              </div>
            </div>
            <Link to="/order-creator/new/products" className="full-btn"><span><Trans>Złóż zamówienie</Trans></span></Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  cart: state.cart
});

Cart.propTypes = propTypes;
export default connect(mapState)(withTranslated(Cart));


// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/subcomponents/cart/Cart.jsx